import { createContext, useState } from "react";
import ClientAxios from "../Client.axios";
import { PAGE_STATUS } from "../interfaces";
import Swal from "sweetalert2";

export const AppContext = createContext<any>({});

export const AppProvider = ({ children }: any) => {

    const [user, __setUser] = useState<any | null>(null);
    const [menuSelected, setMenuSelected] = useState<string | null>(null);

    const [projects, setProjects] = useState<any[]>([]);
    const [selectedProject, __setSelectedProject] = useState<any | null>(null);
    const [planifications, setPlanifications] = useState<any[]>([]);
    const [controlSheets, setControlSheets] = useState<any[]>([]);
    const [transactions, setTransactions] = useState<any[]>([]);

    const setSelectedProject = async (project: any) => {
        console.log("Setting project", project);
        try {
            Swal.fire({
                title: "Cargando proyecto...",
                text: "Por favor espere",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            const client = ClientAxios.getInstance();
            let promises = [
                client.getPlanifications(project._id),
                client.getControlSheets(project._id),
                client.getTransactions(project._id)
            ];
            let [planifications, controlSheets, transactions] = await Promise.all(promises);
            __setSelectedProject(project);
            setPlanifications(planifications.data);
            setControlSheets(controlSheets.data);
            setTransactions(transactions.data);
        } catch (e) {
            console.log(e);
        } finally {
            Swal.close();
        }
    }

    const setUser = (user: any) => {
        sessionStorage.setItem('user', JSON.stringify(user));
        __setUser(user);

        let HTTPclient = ClientAxios.getInstance();
        HTTPclient.getProjects().then((response) => {
            setProjects(response.data);
            if (response.data.length === 1) {
                setSelectedProject(response.data[0]);
            }
        });
    }

    return (
        <AppContext.Provider value={{
            user, setUser,
            menuSelected, setMenuSelected,
            projects, setProjects,
            selectedProject, setSelectedProject,
            planifications, setPlanifications,
            controlSheets, setControlSheets,
            transactions, setTransactions
        }}>
            {children}
        </AppContext.Provider>
    )
}